import React from 'react'

export const AuthModalHost: React.FC = () => {
  return null
}
